/* GENERATED by scripts/gen-tokens.ts from tokens.json — do not edit. */
export const tokens = {
  "color-paper": "#FFFFFF",
  "color-ink": "#1F1B2D",
  "color-muted": "#6F6A82",
  "color-cream": "#FFF6E8",
  "color-sand": "#FFEFD2",
  "color-line": "#F0E8DC",
  "color-coral": "#FF7A7A",
  "color-orange": "#FF9F5A",
  "color-yellow": "#FFCB57",
  "color-violet": "#7C5CFF",
  "color-coral-deep": "#E0564F",
  "color-lavender-soft": "#C9B8FF",
  "color-on-gradient": "#FFFFFF",
  "color-on-yellow": "#1F1B2D",
  "color-semantic-primary": "#FF7A7A",
  "color-semantic-primary-foreground": "#FFFFFF",
  "color-semantic-primary-text": "#E0564F",
  "color-semantic-secondary": "#FFF6E8",
  "color-semantic-secondary-foreground": "#1F1B2D",
  "color-semantic-muted": "#FFF6E8",
  "color-semantic-muted-foreground": "#6F6A82",
  "color-semantic-border": "#F0E8DC",
  "color-semantic-input": "#F0E8DC",
  "color-semantic-ring": "#FFCB57",
  "color-semantic-background": "#FFFFFF",
  "color-semantic-foreground": "#1F1B2D",
  "color-semantic-card": "#FFFFFF",
  "color-semantic-destructive": "#E0564F",
  "color-semantic-celebration": "#7C5CFF",
  "color-signal-chips-watch-time-bg": "#FF7A7A",
  "color-signal-chips-watch-time-fg": "#FFFFFF",
  "color-signal-chips-replays-bg": "#7C5CFF",
  "color-signal-chips-replays-fg": "#FFFFFF",
  "color-signal-chips-shares-bg": "#FF9F5A",
  "color-signal-chips-shares-fg": "#FFFFFF",
  "color-signal-chips-quality-bg": "#FFCB57",
  "color-signal-chips-quality-fg": "#1F1B2D",
  "color-brand-marks-visa": "#1A1F71",
  "color-brand-marks-mastercard-red": "#EB001B",
  "color-brand-marks-mastercard-orange": "#F79E1B",
  "color-brand-marks-paypal-navy": "#003087",
  "color-brand-marks-paypal-blue": "#009CDE",
  "color-brand-marks-google-blue": "#4285F4",
  "color-brand-marks-apple-pay-pill": "#1F1B2D",
  "gradient-primary": "linear-gradient(135deg, #FF7A7A 0%, #FF9F5A 100%)",
  "gradient-primary-css": "linear-gradient(135deg, #FF7A7A 0%, #FF9F5A 100%)",
  "gradient-sun": "linear-gradient(135deg, #FFCB57 0%, #FF9F5A 100%)",
  "gradient-sun-css": "linear-gradient(135deg, #FFCB57 0%, #FF9F5A 100%)",
  "gradient-celebration": "linear-gradient(135deg, #7C5CFF 0%, #FF7A7A 100%)",
  "gradient-celebration-css": "linear-gradient(135deg, #7C5CFF 0%, #FF7A7A 100%)",
  "gradient-thumbnail": "linear-gradient(160deg, #FFCB57 0%, #FF7A7A 100%)",
  "gradient-thumbnail-css": "linear-gradient(160deg, #FFCB57 0%, #FF7A7A 100%)",
  "gradient-surface-soft": "linear-gradient(135deg, #FFF6E8 0%, #FFEFD2 100%)",
  "gradient-surface-soft-css": "linear-gradient(135deg, #FFF6E8 0%, #FFEFD2 100%)",
  "gradient-auth-backdrop": "linear-gradient(180deg, #FFF6E8 0%, #FFFFFF 55%)",
  "gradient-auth-backdrop-css": "linear-gradient(180deg, #FFF6E8 0%, #FFFFFF 55%)",
  "gradient-progress-bar": "linear-gradient(90deg, #FFCB57, #FF9F5A, #FF7A7A)",
  "gradient-progress-bar-css": "linear-gradient(90deg, #FFCB57, #FF9F5A, #FF7A7A)",
  "gradient-text-primary": "linear-gradient(135deg, #FF7A7A, #FF9F5A)",
  "gradient-text-primary-css": "linear-gradient(135deg, #FF7A7A, #FF9F5A)",
  "font-family-sans": "\"Plus Jakarta Sans\", system-ui, -apple-system, Segoe UI, sans-serif",
  "font-weight-regular": "400",
  "font-weight-medium": "500",
  "font-weight-semibold": "600",
  "font-weight-bold": "700",
  "font-weight-extrabold": "800",
  "font-size-display": "68px",
  "font-size-display-mobile": "40px",
  "font-size-h1": "30px",
  "font-size-h1-large": "34px",
  "font-size-h2": "26px",
  "font-size-h2-landing": "34px",
  "font-size-h3": "22px",
  "font-size-title": "20px",
  "font-size-title-sm": "19px",
  "font-size-title-xs": "17px",
  "font-size-body": "15px",
  "font-size-body-sm": "14px",
  "font-size-caption": "13px",
  "font-size-micro": "12px",
  "font-size-tab": "10.5px",
  "font-size-stat-number": "30px",
  "font-line-height-display": "1.02",
  "font-line-height-heading": "1.1",
  "font-line-height-title": "1.15",
  "font-line-height-body": "1.5",
  "font-line-height-caption": "1.35",
  "font-letter-spacing-display": "-0.035em",
  "font-letter-spacing-heading": "-0.03em",
  "font-letter-spacing-title": "-0.02em",
  "font-letter-spacing-label": "0.06em",
  "font-role-display-size": "68px",
  "font-role-display-weight": "800px",
  "font-role-display-line-height": "1.02px",
  "font-role-display-letter-spacing": "-0.035em",
  "font-role-display-mobile": "40px",
  "font-role-h1-size": "30px",
  "font-role-h1-weight": "800px",
  "font-role-h1-line-height": "1.1px",
  "font-role-h1-letter-spacing": "-0.03em",
  "font-role-h2-size": "26px",
  "font-role-h2-weight": "800px",
  "font-role-h2-letter-spacing": "-0.03em",
  "font-role-card-title-size": "22px",
  "font-role-card-title-weight": "800px",
  "font-role-card-title-line-height": "1.15px",
  "font-role-card-title-letter-spacing": "-0.03em",
  "font-role-section-title-size": "17px",
  "font-role-section-title-weight": "800px",
  "font-role-section-title-letter-spacing": "-0.01em",
  "font-role-body-size": "15px",
  "font-role-body-weight": "400px",
  "font-role-body-line-height": "1.5px",
  "font-role-body-strong-size": "15px",
  "font-role-body-strong-weight": "600px",
  "font-role-caption-size": "13px",
  "font-role-caption-weight": "600px",
  "font-role-caption-color": "muted",
  "font-role-label-size": "12px",
  "font-role-label-weight": "800px",
  "font-role-label-letter-spacing": "0.06em",
  "font-role-label-transform": "uppercase",
  "font-role-label-color": "coralDeep",
  "font-role-button-size": "15px",
  "font-role-button-weight": "800px",
  "font-role-button-large-size": "16px",
  "font-role-button-large-weight": "800px",
  "font-role-chip-size": "12px",
  "font-role-chip-weight": "800px",
  "font-role-tab-size": "10.5px",
  "font-role-tab-weight": "800px",
  "space-1": "4px",
  "space-2": "6px",
  "space-3": "8px",
  "space-4": "10px",
  "space-5": "12px",
  "space-6": "14px",
  "space-7": "16px",
  "space-8": "18px",
  "space-9": "20px",
  "space-10": "22px",
  "space-11": "24px",
  "space-12": "28px",
  "space-13": "32px",
  "space-14": "36px",
  "space-15": "40px",
  "space-16": "48px",
  "space-17": "56px",
  "space-gutter-mobile": "20px",
  "space-gutter-desktop": "24px",
  "space-section-gap": "22px",
  "space-section-gap-desktop": "24px",
  "space-card-padding": "22px",
  "space-card-padding-lg": "24px",
  "space-tile-padding": "16px",
  "space-content-max-width": "680px",
  "space-landing-max-width": "1120px",
  "space-sidebar-width": "224px",
  "space-bottom-padding-mobile": "120px",
  "radius-pill": "999px",
  "radius-xl": "28px",
  "radius-lg": "24px",
  "radius-md": "20px",
  "radius-sm": "16px",
  "radius-xs": "14px",
  "radius-chip": "999px",
  "radius-thumbnail": "14px",
  "radius-thumbnail-lg": "18px",
  "radius-icon-badge": "18px",
  "radius-icon-badge-sm": "12px",
  "radius-tab-bar": "28px",
  "radius-tab-item": "22px",
  "radius-device-stack": "32px",
  "shadow-card": "0 6px 20px rgba(31,27,45,0.08)",
  "shadow-card-raised": "0 14px 36px rgba(31,27,45,0.12)",
  "shadow-float": "0 18px 40px rgba(31,27,45,0.16)",
  "shadow-primary-glow": "0 10px 30px rgba(255,122,122,0.30)",
  "shadow-primary-glow-strong": "0 14px 36px rgba(255,122,122,0.32)",
  "shadow-tab-bar": "0 10px 30px rgba(31,27,45,0.14)",
  "shadow-segment-thumb": "0 2px 8px rgba(31,27,45,0.10)",
  "shadow-hero": "0 30px 60px rgba(31,27,45,0.22)",
  "border-chip": "2px solid #F0E8DC",
  "border-input": "2px solid #F0E8DC",
  "border-input-focus": "2px solid #FF9F5A",
  "border-dropzone": "3px dashed #FF9F5A",
  "border-empty-dashed": "2px dashed #F0E8DC",
  "border-avatar-ring": "3px solid #FFFFFF",
  "size-tap-min": "44px",
  "size-button-md": "46px",
  "size-button-lg": "50px",
  "size-button-xl": "54px",
  "size-input-height": "48px",
  "size-tab-bar-item": "56px",
  "size-icon-nav": "24px",
  "size-icon-tile": "26px",
  "size-icon-hero": "32px",
  "size-avatar-sm": "28px",
  "size-avatar-md": "36px",
  "size-avatar-lg": "48px",
  "size-avatar-xl": "64px",
  "size-thumbnail-sm": "48,72",
  "size-thumbnail-md": "64,96",
  "size-thumbnail-lg": "84,130",
  "size-evidence-tile": "168px",
  "size-progress-bar": "8px",
  "size-progress-bar-lg": "10px",
  "size-certainty-bar": "18,6",
  "size-toggle": "56,32",
  "breakpoint-mobile-max": "767px",
  "breakpoint-mobile-nav": "bottom tab bar",
  "breakpoint-mobile-gutter": "20px",
  "breakpoint-mobile-columns": "1px",
  "breakpoint-desktop-min": "768px",
  "breakpoint-desktop-nav": "left sidebar 224px",
  "breakpoint-desktop-gutter": "24px",
  "breakpoint-desktop-content-max-width": "680px",
  "breakpoint-wide-min": "1120px",
  "breakpoint-grids-plan-tiles": "repeat(auto-fit, minmax(160px, 1fr))",
  "breakpoint-grids-how-it-works": "repeat(auto-fit, minmax(250px, 1fr))",
  "breakpoint-grids-detail-tiles": "repeat(auto-fit, minmax(200px, 1fr))",
  "breakpoint-grids-stats": "repeat(3, 1fr)",
  "breakpoint-grids-fields": "repeat(auto-fit, minmax(220px, 1fr))",
  "motion-easing-standard": "ease-out",
  "motion-easing-in-out": "ease-in-out",
  "motion-duration-fast": "200ms",
  "motion-duration-screen-in": "300ms",
  "motion-duration-detail-in": "250ms",
  "motion-duration-pop": "500ms",
  "motion-duration-confetti": "1100ms",
  "motion-duration-bounce": "2400ms",
  "motion-duration-bounce-fast": "1600ms",
  "motion-duration-float": "5000ms",
  "motion-duration-scan": "2200ms",
  "motion-duration-progress-fill": "3400ms",
  "motion-duration-stage-rotate": "1400ms",
  "icon-set": "Phosphor Icons, duotone weight",
  "icon-sizes-nav": "24px",
  "icon-sizes-inline": "16px",
  "icon-sizes-tile": "26px",
  "icon-sizes-hero": "32px",
  "funnel-column-max-width": "480px",
  "funnel-column-gutter": "20px",
  "funnel-column-backdrop": "#FFF6E8",
  "funnel-header-height": "56px",
  "funnel-header-icon": "28px",
  "funnel-progress-segments": "6px",
  "funnel-progress-height": "8px",
  "funnel-progress-gap": "6px",
  "funnel-progress-track": "#F0E8DC",
  "funnel-progress-fill": "linear-gradient(90deg,#FFCB57,#FF9F5A,#FF7A7A)",
  "funnel-timer-card-bg": "linear-gradient(135deg,#1F1B2D,#3A3350)",
  "funnel-timer-card-fill": "linear-gradient(90deg,rgba(255,122,122,.35),rgba(255,159,90,.35))",
  "funnel-timer-card-digit-box": "rgba(255,255,255,.14)",
  "funnel-timer-card-digit": "22/800",
  "funnel-green-bg": "#E8F7EE",
  "funnel-green-fg": "#1F7A3A",
  "funnel-green-text": "#3B5F48",
  "funnel-ig-gradient": "linear-gradient(135deg,#F9CE34,#EE2A7B 55%,#6228D7)",
  "funnel-brand-red": "#C8102E",
  "funnel-option-row-min-height": "64px",
  "funnel-option-row-radius": "20px",
  "funnel-option-row-border": "2px #F0E8DC",
  "funnel-option-row-selected-border": "#FF9F5A",
  "funnel-option-row-selected-fill": "#FFF6E8",
  "funnel-option-row-glyph-badge": "34px",
  "funnel-two-up-radius": "28px",
  "funnel-two-up-icon-badge": "64px",
  "funnel-two-up-primary-tile": "gradient.primary",
  "funnel-two-up-secondary-tile": "#FFF6E8",
  "funnel-slider-track": "10px",
  "funnel-slider-thumb": "34px",
  "funnel-slider-thumb-dragging": "scale 1.25",
  "funnel-slider-minor-ticks": "5%",
  "funnel-swipe-card": "350×300 r28",
  "funnel-swipe-behind": "0.96,0.92",
  "funnel-swipe-flag-yes": "gradient.celebration white",
  "funnel-swipe-flag-no": "#1F1B2D white",
  "funnel-swipe-fly": "420ms arc",
  "funnel-hold-reveal-card": "220px",
  "funnel-hold-reveal-hold-ms": "600px",
  "funnel-hold-reveal-ring": "72px",
  "funnel-hold-reveal-blur-max": "8px",
  "funnel-loader-ring": "96px",
  "funnel-loader-step-ms": "2200,2000,2000",
  "funnel-loader-detail-reveal": "fk-in 300ms",
  "funnel-loader-variants": "numbers,profile,plan",
  "funnel-plan-card-blocks": "aboutYou #FFF6E8,projectedReach gradient.sun,firstMoves gradient.celebration",
  "funnel-motion-screen-in": "300px",
  "funnel-motion-fast": "200px",
  "funnel-motion-pop": "500px",
  "funnel-motion-confetti": "1100px",
  "funnel-motion-scan": "2200px",
  "funnel-motion-auto-advance": "250px"
} as const;

export type TokenName = keyof typeof tokens;

export const tk = (name: TokenName): string => tokens[name];
